
<template>
   <v-dialog
      v-model="showHelp"
      max-width="800"
    >
      <v-card class="pb-3">
        <v-toolbar color="green darken-3" dark>
        <v-toolbar-title class="headline">About Room Association</v-toolbar-title>
      </v-toolbar>

        <v-card-text class="ml-2 mt-3">
          Room Association is the process of associating a room graphic with a Space Database record.<br><br>
          The room graphics for association come from scripts that are run via remote session on pdc-betaGIS2 using CAD files copied to pdc-betaGIS2/interiors/CAD. 
          These are temporary graphics established in the interiorInitial GIS service for the sole purpose of association and are not used in the other operations of Interactive Floorplans.
          The reason a temporary process exists is so that Space Mgmt users do not have to wait for a nightly processing job or georeferencing to associate.  
          <br><br>The nightly CAD-to-GIS Scripting process will use the association created here for the normal operation of Interactive Floorplans.
          <br><br>Full instructions: \\pdc-file.catnet.arizona.edu\share\Space Management\Space App Development\Interactive Floorplans Room Association.docx
          <br><br>

          Abbreviated Steps:
          <ul>
          <li>Ensure Building exists in IF Building Viewer.</li>
          <li>Ensure Floors exist and are mapped to drawing names.</li>
          <li>Open Remote Desktop Session with PDC-betaGIS2</li>
          <li>Copy CAD (DWG) to C:\interiors\CAD on PDC-BetaGIS2. Do not copy .wld files.</li>
          <li>Double click “RunScripts” on desktop and type Upload [building alpha] (e.g. upload 137)</li>
          <li>After script completes, go to Interactive Floorplans.
          <li>Select the floor to update.</li>
          <li>In Building Search (top of app), type example:‘137-2’ to display that building floor.</li>
          <li>Building should be selected now in database area.  If not ensure building exists in Building Viewer.</li>
          <li>Click a room graphic, select the room in database panel, use copy ehandle and copy area buttons to associate.</li>
          <li>Or use AutoRoom to create rooms as they are clicked.</li>          
          </ul>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-layout align-items-center>
          <v-btn color="green darken-1"
            flat="flat"
            @click.stop="setShowHelpRoomAssociation(false)"
          > OK
          </v-btn>
      </v-layout>
        </v-card-actions>

      </v-card>
    </v-dialog>

</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'HelpRoomAssociation',

  computed: {
      showHelp: {
          get () { return this.$store.state.ui.showHelpRoomAssociation },
          set (value) { this.setShowHelpRoomAssociation(false) }
      },
  },
  
  methods : {
      ...mapMutations(['setShowHelpRoomAssociation',]),
  },
}

</script>





// WEBPACK FOOTER //
// src/components/help/HelpRoomAssociation.vue